import i18next from "i18next";
import React from "react";
import { formatDate } from "../../Checkout/sections/TimeSlotSelect/formatDateTime";
import PropTypes from "prop-types";
import moment from "moment";
import { fetchStoreData } from "../../../Api/storeApi";

const DeliveryMessage = ({ slotBegin, slotEnd, storeId }) => {
    const cookie = window.cookie.get();
    const { storePickupAddress } = fetchStoreData(storeId);

    const deliveryDay = moment(slotBegin).format("YYYY-MM-DD");
    const timeSlotBegin = moment(slotBegin).format("HH:mm");
    const timeSlotEnd = moment(slotEnd).format("HH:mm");
    const timeSlotPrintable = `${timeSlotBegin} - ${timeSlotEnd} Uhr`;

    const isDelivery = cookie.area.type === "delivery";
    const deliveryDayFormatted = formatDate(deliveryDay).append;

    return (
        <>
            {isDelivery ? (
                <p className="order_confirmation_message">
                    {i18next.t("orderConfirmation.deliveryMessage.text")}
                    <b>{deliveryDayFormatted}</b>
                    {i18next.t("orderConfirmation.deliveryMessage.between")}
                    <b>{timeSlotPrintable}</b>
                </p>
            ) : (
                <p className="order_confirmation_message">
                    {i18next.t("orderConfirmation.pickupMessage.text")}
                    <b>{deliveryDayFormatted}</b>
                    {i18next.t("orderConfirmation.pickupMessage.between")}
                    <b>{timeSlotPrintable}</b>
                    {i18next.t("orderConfirmation.pickupMessage.at")}
                    {storePickupAddress}
                </p>
            )}
        </>
    );
};

DeliveryMessage.propTypes = {
    slotBegin: PropTypes.string,
    slotEnd: PropTypes.string,
    storeId: PropTypes.number,
};

export default DeliveryMessage;
